import { workshopName } from '@edgvr-front/workshops/domain';
import { dataStartDateTime } from './dataStartDateTime';
import { dataAccountInfo } from './dataAccountInfo';
import { dataAssessorInfo } from './dataAssessorInfo';
import { dataHostInfo } from './dataHostInfo';
import { dataFinishedDateTime } from './dataFinishedDateTime';
import { dataModuleVORaw } from './dataModuleVORaw';
import { dataId } from './dataId';
import { dataSessionInfo } from './dataSessionInfo';
import { dataDateOfEntry } from './dataDateOfEntry';

export const dataVORaw = {
  type: 'object',
  required: [
    'WorkshopName',
    'ModuleStatistics',
    'StartDateTime',
    'AccountInfo',
    'AssessorInfo',
    'HostInfo',
    'SessionInfo',
    'FinishedDateTime',
    'uniqueId',
    'DateOfEntry',
  ],
  properties: {
    WorkshopName: workshopName,
    ModuleStatistics: {
      type: 'array',
      items: dataModuleVORaw,
    },
    StartDateTime: dataStartDateTime,
    AccountInfo: dataAccountInfo,
    AssessorInfo: dataAssessorInfo,
    HostInfo: dataHostInfo,
    SessionInfo: dataSessionInfo,
    FinishedDateTime: dataFinishedDateTime,
    uniqueId: dataId,
    DateOfEntry: dataDateOfEntry,
  },
};
